module.exports = __webpack_public_path__ + "lp/img/background-icn-darkgray.6815c067.svg";